import TasksGeneratorContainer from './TasksGenerator.container';
import TasksGeneratorComponent from './TasksGenerator.component';

export default TasksGeneratorContainer(TasksGeneratorComponent);
